import type { FaireProductEntity } from "../../entity_types/product";

export const p_p24sae67j2: FaireProductEntity = {
  token: "p_p24sae67j2",
  type: "product",
  name: "MERMAID MAXI CROCHET SKIRT",
  brandToken: "b_22tswwgnqb",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/02af07d739a650a259529870e9d56d54c16d7b178ef143da0e145034f49a32fb.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c33cfbc08e3f9cf4ff2f552f1268c3388153e966225737347dd226b0a2f9d67a.jpeg",
    "https://cdn.faire.com/fastly/8ac36daab1f101a236409bc8b1d197425e005d2531fb60da2be1ced97a50009d.jpeg",
    "https://cdn.faire.com/fastly/df1ceb86d9999ba3baf3b433c9ef626abd986fc7166629ef3b8b05cb07d6eeb7.jpeg",
    "https://cdn.faire.com/fastly/6ed08ebd7a4c9ef55cf4d023606c124b3a973dfe29d02d7196b72be694a5caa2.jpeg",
    "https://cdn.faire.com/fastly/24bc268350541904276e6377aac9cd5c98533cc4e135bd0de82038305af6b6f9.jpeg",
    "https://cdn.faire.com/fastly/bc41710b742e1ff8bfa3483cb80902676e08e9e934ebafc34900b5977360c5b5.jpeg",
    "https://cdn.faire.com/fastly/cf985a1b6e72312ca829e51266e383dd26543c1fe5e11fef7a831e6295eb17ae.jpeg",
    "https://cdn.faire.com/fastly/9a858680899269b88586818de2d0e465188234436484a4bf444956eb15e80905.jpeg",
    "https://cdn.faire.com/fastly/87de53affb7e869d7279c3d8d77ec02b4a77234e7c0950afc903c7897f43cf0c.jpeg",
  ],
  priceDollars: 145.5,
  description: "SIZE & FIT :\n\nMODEL WEARS SIZE SMALL\nMODEL'S HEIGHT 5'9",
  tags: [],
  msrpDollars: 290.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:12.155Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
